// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"e4990dc7","351":"d6e4b5ba","578":"3920da8b"}[chunkId] + ".chunk.js";
};